import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectError } from 'services/error/selectors';

// Types
import { Namespace } from 'types';
import { AppState } from 'services/types';

export interface OwnProps {
    namespace: Namespace;
}

interface ConnectedProps {
    errorValue?: string;
}

type Props = OwnProps & ConnectedProps;

export class ErrorValue extends React.PureComponent<Props> {
    render(): string | null {
        const { errorValue } = this.props;
        if (!errorValue) {
            return null;
        }
        return errorValue;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    errorValue: makeSelectError()
});

export default connect(mapStateToProps)(ErrorValue);
